import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  viboTimeInput: {
    fontSize: '13px',
    lineHeight: '18.2px',
    width: '80px',
    display: 'inline',
    border: 'none',
    color: 'var(--text-primary)',
    backgroundColor: 'var(--background-paper)',
    outline: 'none',

    '&:not(.empty)': {
      textTransform: 'lowercase',
    },

    '&.withBorder': {
      padding: '0 14px 0 6px!important',

      '@media screen and (min-width: 1441px)': {
        width: '95px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      width: '85px',
      fontSize: '14px',
      lineHeight: '21px',
    },
  },

  timePickerOverlay: {
    '& .overlayWrapper': {
      width: 'fit-content',
      backgroundColor: 'var(--background-dropDown)',
    },
  },

  timePickerToggle: {
    '&.viboCard': {
      boxShadow: 'none',
    },
  },

  optionsScroll: {
    borderRadius: '4px',
    width: 'fit-content',
    maxHeight: '150px',
    scrollbarWidth: 'none',

    '@media screen and (min-width: 1441px)': {
      maxHeight: '165px',
    },
  },

  tooltipContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '3px',

    '& .tooltipIcon': {
      margin: '-3px',
      color: 'var(--primary-main)',
      padding: '3px',
      borderRadius: '50%',

      '&:hover': {
        backgroundColor: 'var(--primary-light)',
      },
    },
  },

  clearTimeWrapper: {
    position: 'relative',

    '& .viboSpinner, & .clearIcon': {
      color: 'var(--primary-main)',
      position: 'absolute',
      right: '5px',
      top: '50%',
      transform: 'translateY(-50%)',
    },

    '& .clearIcon': {
      zIndex: 2,
      cursor: 'pointer',
      display: 'none',
      color: 'var(--primary-main)',
    },

    '&:hover': {
      '& .clearIcon': {
        display: 'block',
      },
    },

    '&.iconUnderlinePosition': {
      '& .viboSpinner, & .clearIcon': {
        top: '43%',
      },
    },
  },

  timeOptions: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    height: 'fit-content',
    width: 'fit-content',

    '& li': {
      fontSize: '13px',
      lineHeight: '18.2px',
      cursor: 'pointer',
      padding: '6px 12px 6px 6px',
      whiteSpace: 'nowrap',

      '&.active': {
        backgroundColor: 'var(--primary-lighty)',
      },

      '&:hover': {
        backgroundColor: 'var(--primary-light)',
        color: 'var(--clr-white)',
      },

      '@media screen and (min-width: 1441px)': {
        fontSize: '14px',
        lineHeight: '21px',
      },
    },
  },
}));

export default useStyles;
